import {gsap} from "../../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';

// Constructor
export class GameCActionButtons extends PIXI.Container {

  constructor(game) {
    super();

    this.game = game;

    this.lastWalkTimer = false;

    this.activePad = null;
    this.otherPad = null;

    this.isDragging = false;

    this.isIdling = false;
    this.noProgressTimer = false;

    this.buttonWidth = 0;

    this.build(game);

    this.disable();

  }

  build() {
    this.sortableChildren = true

    this.leftPadSprite = new PIXI.Sprite(PIXI.Texture.from("foot-button"));
    this.buttonWidth = this.leftPadSprite.width;
    this.leftPadSprite.id = "left";
    this.leftPadSprite.anchor.set(0.5, 0.5);
    this.leftPadSprite.position.set(this.buttonWidth / 2, this.buttonWidth / 2);
    this.leftPadSprite.eventMode = "none";
    this.leftPadSprite.zIndex = 1;
    this.addChild(this.leftPadSprite);

    this.minPosY = this.buttonWidth / 2;
    this.maxPosY = this.leftPadSprite.height + this.buttonWidth / 2;

    this.rightPadSprite = new PIXI.Sprite(PIXI.Texture.from("foot-button"));
    this.rightPadSprite.id = "right";
    this.rightPadSprite.anchor.set(0.5, 0.5);
    this.rightPadSprite.position.set(this.rightPadSprite.width - 20 + this.buttonWidth / 2, this.maxPosY);
    this.rightPadSprite.eventMode = "none";
    this.rightPadSprite.zIndex = 0;
    this.addChild(this.rightPadSprite);

    this.idleContainer = new PIXI.Container();
    this.idleContainer.eventMode = "none";
    this.addChild(this.idleContainer);

    this.idleArrow = new PIXI.Sprite(PIXI.Texture.from("idle-arrow"));
    this.idleArrow.position.set(60, 60);
    this.idleArrow.anchor.set(1, 1);
    this.idleArrow.alpha = 0;
    this.idleArrow.eventMode = "none";
    this.idleContainer.addChild(this.idleArrow);

    this.idleArrow2 = new PIXI.Sprite(PIXI.Texture.from("down-arrow"));
    this.idleArrow2.position.set(this.leftPadSprite.width / 2, 20);
    this.idleArrow2.anchor.set(0.5, 0);
    this.idleArrow2.alpha = 0;
    this.idleArrow2.eventMode = "none";
    this.idleContainer.addChild(this.idleArrow2);

    this.buildIdleAnimation();

  }

  buildIdleAnimation() {

    // Idle animation when no action for X seconds
    this.idleAnimationTimeline = gsap.timeline({
      defaults: {
        // repeat: -1,
        // immediateRender: true,
      },
      paused: true,
      repeat: -1,
    });

    // Fade in container
    this.idleAnimationTimeline.fromTo(this.idleContainer,
      {
        pixi: {
          alpha: 0
        },
      },
      {
        pixi: {
          alpha: 1
        },
        immediateRender: true,
        duration: 0.25,
        overwrite: "auto",
      }, 0);

    // Bounce idle arrow
    this.idleAnimationTimeline.fromTo(this.idleArrow,
      {
        pixi: {
          x: 0,
          y: 0,
          alpha: 1,
        }
      },
      {
        pixi: {
          x: 30,
          y: 30,
          alpha: 1,
        },
        duration: 1,
        ease: "sine.inOut",
        repeat: 2,
        yoyo: true,
        overwrite: "auto",
      })

    // Fade idle arrow
    this.idleAnimationTimeline.fromTo(this.idleArrow2,
      {
        pixi: {
          alpha: 0
        },
      },
      {
        pixi: {
          alpha: 1
        },
        immediateRender: true,
        duration: 0.25,
        overwrite: "auto",
      });

    // Bounce idle arrow
    this.idleAnimationTimeline.fromTo(this.idleArrow2,
      {
        pixi: {
          y: 280,
          // alpha: 1,
        }
      },
      {
        pixi: {
          y: 310,
          // alpha: 1,
        },
        duration: 1,
        ease: "sine.inOut",
        repeat: 2,
        yoyo: true,
        overwrite: "auto",
      }, "-=0.25")

    // Fade out everything
    this.idleAnimationTimeline.to(this.idleContainer,
      {
        pixi: {
          alpha: 0
        },
        duration: 0.5,
      })

  }

  startIdleMode() {
    this.isIdling = true;
    this.idleAnimationTimeline.progress(0);
    this.idleAnimationTimeline.play();
  }

  stopIdleMode() {

    this.isIdling = false;

    gsap.to([this.idleContainer],
      {
        pixi: {
          alpha: 0
        },
        overwrite: "auto",
        duration: 0.5,
        onComplete: () => {
          this.idleAnimationTimeline.pause();
          this.idleAnimationTimeline.progress(0);
        }
      })
  }

  enable() {
    // console.log("enable buttons");

    this.removeAllEvents();

    this.leftPadSprite.eventMode = "static";
    this.rightPadSprite.eventMode = "static";

    this.leftPadSprite.on("pointerdown", this.onStartDrag, this);
    this.rightPadSprite.on("pointerdown", this.onStartDrag, this);

    this.eventMode = "static";
    this.game.stage.on("pointerup", this.onStopDrag, this)
    this.game.stage.on("pointerupoutside", this.onStopDrag, this);

    this.startNoActionTimer();
  }

  disable(immediate) {
    let duration = typeof immediate !== "undefined" ? 0 : 0.5;
    // console.log("disable buttons");

    this.leftPadSprite.eventMode = "none";
    this.rightPadSprite.eventMode = "none";
    this.eventMode = "none";

    this.removeAllEvents();

    this.isDragging = false;

    // gsap.to(this.sprite,
    //   {
    //     pixi: {
    //       scale: 0,
    //     },
    //     overwrite: "auto",
    //     duration: duration,
    //     onComplete: () => {
    //     }
    //   }
    // )
    //
    // gsap.to(this,
    //   {
    //     pixi: {
    //       alpha: 0,
    //     },
    //     overwrite: "auto",
    //     duration: duration,
    //   }
    // )
  }

  onStartDrag(e) {
    // console.log("start drag", e.target.id);
    this.game.onTouchDown(e);
    this.isDragging = true;

    if (e.target.id == "left") {
      this.activePad = this.leftPadSprite;
      this.otherPad = this.rightPadSprite;
    } else {
      this.activePad = this.rightPadSprite;
      this.otherPad = this.leftPadSprite;
    }

    this.startPadY = this.activePad.position.y;
    this.startDragPos = this.toLocal(e.global, null);

    this.activePad.zIndex = 1;
    // this.activePad.eventMode = "none";
    this.otherPad.zIndex = 0;
    // this.otherPad.eventMode = "none";
    this.leftPadSprite.off("pointerdown", this.onStartDrag, this);
    this.rightPadSprite.off("pointerdown", this.onStartDrag, this);

    gsap.to([this.leftPadSprite, this.rightPadSprite], {
      duration: 0.2,
      pixi: {scale: 0.9}
    })

    this.stopNoActionTimer();
    this.stopIdleMode();

    this.game.stage.on("pointermove", this.onMove, this);
  }

  onMove(e) {
    // console.log("on move", this.activePad.id, this.isDragging);
    if (!this.isDragging) {
      return;
    }

    let currentPos = this.toLocal(e.global, null);
    let distanceMoved = currentPos.y - this.startDragPos.y;
    let newTargetY = Math.max(this.minPosY, Math.min(this.startPadY + distanceMoved, this.maxPosY));

    this.activePad.position.y = newTargetY;
    this.otherPad.position.y = window.map(newTargetY, this.minPosY, this.maxPosY, this.maxPosY, this.minPosY); // inverse value

    this.emit("walk", {});

    if (this.lastWalkTimer !== false) {
      clearTimeout(this.lastWalkTimer);
      this.lastWalkTimer = false;
    }

    // if no movement is detected after X ms, act as stop walking
    this.lastWalkTimer = setTimeout(() => {
      this.emit("stop-walk", {});
    }, 100);
  }

  onStopDrag(e) {
    if (!this.isDragging) {
      return;
    }

    this.emit("stop-walk", {});
    // console.log("stop drag", this.activePad.id);
    // this.activePad.alpha = 1;
    this.leftPadSprite.on("pointerdown", this.onStartDrag, this);
    this.rightPadSprite.on("pointerdown", this.onStartDrag, this);

    this.activePad.eventMode = "static";
    this.otherPad.eventMode = "static";

    gsap.to([this.leftPadSprite, this.rightPadSprite], {
      duration: 0.2,
      pixi: {scale: 1.0}
    })

    this.game.stage.off("pointermove", this.onMove, this);
  }

  removeAllEvents() {
    this.leftPadSprite.off("pointerdown", this.onStartDrag, this);
    this.rightPadSprite.off("pointerdown", this.onStartDrag, this);

    this.game.stage.off("pointermove", this.onMove, this);
    this.game.stage.off("pointerup", this.onStopDrag, this)
    this.game.stage.off("pointerupoutside", this.onStopDrag, this);
  }

  startNoActionTimer() {
    this.stopNoActionTimer();

    this.noProgressTimer = setTimeout(() => {
      this.startIdleMode();
    }, 5000)
  }

  stopNoActionTimer() {
    if (this.noProgressTimer !== false) {
      clearTimeout(this.noProgressTimer);
      this.noProgressTimer = false;
    }
  }

  reset() {
    this.stopIdleMode();
    this.stopNoActionTimer();

    this.disable();

    this.lastWalkTimer = false;
    this.activePad = null;
    this.otherPad = null;
    this.isDragging = false;
    this.isIdling = false;

    this.leftPadSprite.position.set(this.buttonWidth / 2, this.buttonWidth / 2);
    this.rightPadSprite.position.set(this.buttonWidth - 20 + this.buttonWidth / 2, this.maxPosY);

    this.idleAnimationTimeline.pause();
    this.idleAnimationTimeline.progress(0);
  }

}
